<template>
  <div>
    <v-dialog
      ref="vdialog"
      v-model="dialog"
      transition="dialog-bottom-transition"
      hide-overlay
      fullscreen
      persistent
    >
      <v-card tile>
        <v-card-title class="modal__title px-4 pt-4 pb-4">
          <h3>
            {{ $t(`create.label.${type}`) }}
          </h3>
          <v-spacer />
          <v-btn
            @click="
              confirmToClose
                ? openModal('CONFIRM_CLOSE_APPOINTMENT_MODAL')
                : closeCreateModal()
            "
            color="primary"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="dialog" ref="content" class="pt-5 white text-body-1">
          <slot />
        </v-card-text>
      </v-card>
    </v-dialog>

    <ModalConfirmToClose @closeCreateModal="closeCreateModal" />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

import ModalConfirmToClose from '@/components/app/modal/ModalConfirmToClose'

export default {
  name: 'CreateModal',

  components: {
    ModalConfirmToClose,
  },

  props: {
    type: {
      type: String,
      required: true,
    },

    confirmToClose: {
      type: Boolean,
      default: false,
    },

    customCallButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialog: false,
    }
  },

  methods: {
    ...mapActions(['openModal', 'closeModal', 'resetAppointmentFields']),
    ...mapMutations(['setAppointmentCreationConfirmToClose']),

    closeCreateModal() {
      this.scrollToTop()
      this.resetAppointmentFields()
      this.setAppointmentCreationConfirmToClose(false)
      this.$emit('closeCreateModal')
      this.closeModal('CONFIRM_CLOSE_APPOINTMENT_MODAL')

      this.dialog = false
    },

    openCreateModal() {
      this.dialog = true
    },

    scrollToTop() {
      this.$refs?.vdialog?.$refs?.dialog?.scrollTo(0, 0)
    },
  },
}
</script>
